let instance = null

export default class AudioService {
  constructor() {
    this.audio = null
    this.audioFileKey = null
  }

  getAudioPlayer() {
    return this.audio
  }

  stopAudio() {
    if (this.audio?.pause) {
      this.audio.pause()
    }
  }

  playAudio(audioBinary, audioFileKey, onEnd = () => {}, onStart = () => {}) {
    if (this.audio?.pause) {
      this.audio.pause()
    }

    const audioBlob = new Blob([audioBinary], { type: 'audio/mp3' })
    const audioUrl = URL.createObjectURL(audioBlob)

    this.audio = new Audio(audioUrl)
    this.audioFileKey = audioFileKey
    this.audio.onended = event => {
      onEnd()
    }
    this.audio.onplaying = event => {
      onStart()
    }
    this.audio.play()
  }
}

export const audioInstance = () => {
  return instance || (instance = new AudioService())
}
